import { DunsCompanyInfo } from "@/types";
import { axios, APIBASE_REVIVERUSERS } from "./ApiConfig";
import { useQuery } from "@tanstack/react-query";
import { transformCompanyData } from "@/utils/duns";

export const getCompanyByOrgNumber = (orgNumber: string) =>
  axios.get(`${APIBASE_REVIVERUSERS}api/company/invite/searchByOrgNumber/${orgNumber}`);

export const useGetCompanyByOrgNumber = (orgNumber: string, options: any) => {
  useQuery<DunsCompanyInfo>({
    queryKey: ["getCompanyByOrgNumber", orgNumber],
    queryFn: async () => {
      const result = await getCompanyByOrgNumber(orgNumber);
      return transformCompanyData(result.data);
    },
    enabled: !!orgNumber,
    ...options,
  });
};

export const getByEntityId = (entityId: string) =>
  axios.get(`${APIBASE_REVIVERUSERS}api/company/invite/getByEntityId/${entityId}`);

export const useGetByEntityId = (entityId: string, options: any) => {
  useQuery<DunsCompanyInfo>({
    queryKey: ["getByEntityId", entityId],
    queryFn: async () => {
      const result = await getByEntityId(entityId);
      return transformCompanyData(result.data);
    },
    enabled: !!entityId,
    ...options,
  });
};

export const getByDuns = (duns: string) => axios.get(`${APIBASE_REVIVERUSERS}api/company/invite/getByDuns/${duns}`);

export const useGetByDuns = (duns: string, options: any) => {
  useQuery<DunsCompanyInfo>({
    queryKey: ["getByDuns", duns],
    queryFn: async () => {
      const result = await getByDuns(duns);
      return transformCompanyData(result.data);
    },
    enabled: !!duns,
    ...options,
  });
};

export const inviteCompany = (duns: string, contractTemplateIds: number[]) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/invite`, {
    duns,
    contractTemplateIds,
  });

export const startScreeningCompany = (duns: string) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/startScreening/${duns}`);

export const createEntity = (duns: string) => axios.post(`${APIBASE_REVIVERUSERS}api/company/createEntity/${duns}`);

export const rejectInvitedCompany = (companyId: number) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/invite/${companyId}/reject`);

export const approveInvitedCompany = (companyId: number) =>
  axios.post(`${APIBASE_REVIVERUSERS}api/company/invite/${companyId}/approve`);
